module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "insights_secondary"
  }, [_c('div', {
    staticClass: "insightCards"
  }, [_c('div', {
    staticClass: "topRowCards"
  }, [_c('div', {
    staticClass: "xsCard xsLong"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer"
  }, [_c('div', {
    staticClass: "viewershipGraphContainer__graph"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__rows"
  }, _vm._l((_vm.secondaryInsightViewershipMockData.viewership.slice(0, 5)), function(v, index) {
    return _c('div', {
      key: v.id,
      staticClass: "viewershipGraphContainer__graph__rows__rowDetail"
    }, [_c('div', {
      staticClass: "viewershipGraphContainer__graph__rows__rowDetail__index"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__rows__rowDetail__rowItem blue"
    }, [_vm._v(_vm._s(v.network))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__rows__rowDetail__rowItem"
    }, [_vm._v(_vm._s(v.comp))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__rows__rowDetail__rowItem"
    }, [_vm._v(_vm._s(v.reach))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__rows__rowDetail__rowItem"
    }, [_vm._v(_vm._s(v.indexVal))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__right"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__right__rows"
  }, _vm._l((_vm.secondaryInsightViewershipMockData.viewership.slice(5)), function(v, index) {
    return _c('div', {
      key: v.id,
      staticClass: "viewershipGraphContainer__graph__right__rows__rowDetail"
    }, [_c('div', {
      staticClass: "viewershipGraphContainer__graph__right__rows__rowDetail__index"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__right__rows__rowDetail__rowItem blue"
    }, [_vm._v(_vm._s(v.network))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__right__rows__rowDetail__rowItem"
    }, [_vm._v(_vm._s(v.comp))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__right__rows__rowDetail__rowItem"
    }, [_vm._v(_vm._s(v.reach))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__right__rows__rowDetail__rowItem"
    }, [_vm._v(_vm._s(v.indexVal))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottomRowCards"
  }, [_c('div', {
    staticClass: "xsCard xsShort"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v("Digital Affinities")]), _vm._v(" "), _c('div', {
    staticClass: "digitalAffinities"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "digitalAffinities__rows"
  }, _vm._l((_vm.secondaryInsightViewershipMockData.digitalAffinities), function(da) {
    return _c('div', {
      key: da.property,
      staticClass: "digitalAffinities__rows__rowDetail"
    }, [_c('div', {
      staticClass: "rowItem"
    }, [_vm._v(_vm._s(da.property))]), _vm._v(" "), _c('div', {
      staticClass: "rowItem"
    }, [_vm._v(_vm._s(_vm.formattedCount(da.monthlyUnique)))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "xsCard xsShort"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v("OTS Segment Affinities")]), _vm._v(" "), _c('div', {
    staticClass: "otsSegmentAffinities"
  }, _vm._l((_vm.secondaryInsightViewershipMockData.segmentAffinities), function(sa) {
    return _c('div', {
      key: sa.segment,
      staticClass: "otsSegmentAffinities__row"
    }, [_c('div', {
      staticClass: "otsSegmentAffinities__row__value"
    }, [_vm._v(_vm._s(sa.value) + "  - ")]), _vm._v(" "), _c('div', {
      staticClass: "otsSegmentAffinities__row__segmentName"
    }, [_vm._v(_vm._s(sa.segment))])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card__titleRow"
  }, [_c('div', {
    staticClass: "card__titleRow__name"
  }, [_vm._v("Viewership")]), _vm._v(" "), _c('div', {
    staticClass: "card__titleRow__button"
  }, [_c('div', {
    staticClass: "card__titleRow__button__text"
  }, [_vm._v("Networks")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewershipGraphContainer__graph__headers"
  }, [_c('div', {
    staticClass: "viewershipGraphContainer__graph__headers__index"
  }, [_vm._v("  ")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__headers__headerItem"
  }, [_vm._v("Network")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__headers__headerItem"
  }, [_vm._v("Comp")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__headers__headerItem"
  }, [_vm._v("Reach")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__headers__headerItem"
  }, [_vm._v("Index")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewershipGraphContainer__graph__right__headers"
  }, [_c('div', {
    staticClass: "viewershipGraphContainer__graph__right__headers__index"
  }, [_vm._v("  ")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__right__headers__headerItem"
  }, [_vm._v("Network")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__right__headers__headerItem"
  }, [_vm._v("Comp")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__right__headers__headerItem"
  }, [_vm._v("Reach")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__right__headers__headerItem"
  }, [_vm._v("Index")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "digitalAffinities__headers"
  }, [_c('div', {
    staticClass: "headerItem"
  }, [_vm._v("Property")]), _vm._v(" "), _c('div', {
    staticClass: "headerItem"
  }, [_vm._v("Uniques/Month")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e97147b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/insights/secondary.vue
// module id = 1939
// module chunks = 0